import kids1 from './scenes/kids1'
import kids2 from './scenes/kids2'
import kids3 from './scenes/kids3'
import kids4 from './scenes/kids4'
import kids5 from './scenes/kids5'
import adults1 from './scenes/adults1'
import adults2 from './scenes/adults2'
import adults3 from './scenes/adults3'
import adults4 from './scenes/adults4'
import adults5 from './scenes/adults5'

export default {

  'scene1adults': adults1,
  'scene2adults': adults2,
  'scene3adults': adults3,
  'scene4adults': adults4,
  'scene5adults': adults5,
  'scene1kids': kids1,
  'scene2kids': kids2,
  'scene3kids': kids3,
  'scene4kids': kids4,
  'scene5kids': kids5,


}
